import React from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

import heroSection_four from '../../../Assets/resource/VMEVLifeApp.png';
import appstore from '../../../Assets/shared/app_link_apple.svg';
import playstore from '../../../Assets/shared/app_link_playstore.svg';



export default function MobileApp() {
    const navigate = useNavigate();
    return (
        <section className="bg-light-gradient blade-margin-sm">
                <div className="text-center">
                    <h3 className="text-center font-gilroy">
                        VerdeMobility <br /> <b> EV Life App </b>
                    </h3>
                </div>
            <div className="z-10 containers-min mx-auto sm:flex  md:flex-row flex-col sm:items-center mt-10">
                <div className="md:w-6/12 h-fit flex justify-center items-start flex-col min-w-[300px] ">
                    <p className="leading-normal font-poppins text-start px-5 pt-4 text-base md:text-xl lg:text-2xl">
                        Enjoy easy and blissful EV Charging with VerdeMobility EV Life App. An intuitive iOS and Android application that gives your residents access to the entire world of EV Charging in a tap.
                    </p>
                    <div className="flex flex-wrap md:gap-8 gap-4 items-center justify-center max-w-2xl w-full  mt-4  md:mt-6  xl:mt-10 mx-auto  ">
                        <a
                            href="https://apps.apple.com/in/app/verdemobility/id1622189313"
                            className="max-w-[120px] md:max-w-[300px] md:min-w-[200px]"
                            rel="noreferrer"
                            target="_blank"
                        >
                            <span className="sr-only">Download IOS app</span>

                            <img
                                loading="lazy"
                                src={appstore}
                                className="py-2 "
                                alt="app strore link"
                            />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.verdemobility.ev.charger"
                            className="max-w-[120px] md:max-w-[300px] md:min-w-[200px]"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span className="sr-only">Download Android app</span>
                            <img
                                loading="lazy"
                                src={playstore}
                                className="py-2"
                                alt="play strore link"
                            />
                        </a>
                    </div>
                </div>

                <div className="md:w-5/12 w-full p-4 md:mt-0 mt-10 mx-auto relative lg:min-h-[400px] min-h-[300px]">
                    <div className="absolute top-0 left-auto bottom-0 -right-20 bg-gradient w-32 md:w-56 lg:w-80 hidden md:block"></div>
                    <img
                        loading="lazy"
                        className="h-full w-full rounded-lg z-10 relative"
                        src={heroSection_four}  
                        alt="Switch to EV"
                    />
                </div>
            </div>
        </section>
    );
}
